<template>
  <div class="modal fade" id="new-food-hygene" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-capitalize" id="exampleModalLongTitle">Food Hygiene Certificate Application</h5>
          <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>

          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-email-input" class="form-label">Business ID</label>
                <input
                    v-model="localApplication.businessID"
                    type="text"
                    class="form-control"
                    placeholder="Enter Business ID"
                >
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-email-input" class="form-label">Business Name</label>
                <input
                    v-model="localApplication.businessName"
                    type="text"
                    class="form-control"
                    placeholder="Enter Business Name"
                >
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-email-input" class="form-label">PIN Number</label>
                <input
                    v-model="localApplication.pinNumber"
                    type="text"
                    class="form-control"
                    placeholder="KRA Pin Number"
                >
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-email-input" class="form-label">Plot Number</label>
                <input
                    v-model="localApplication.plotNumber"
                    type="text"
                    class="form-control"
                    placeholder="Enter plot Number"
                >
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-email-input" class="form-label">Phone Number</label>
                <input
                    v-model="localApplication.phoneNumber"
                    type="text"
                    class="form-control"
                    placeholder="Enter phone No."
                >
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-email-input" class="form-label">Email Address</label>
                <input
                    v-model="localApplication.email"
                    type="text"
                    class="form-control"
                    placeholder="email@email.com"
                >
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-email-input" class="form-label">PO Box</label>
                <input
                    v-model="localApplication.poBox"
                    type="text"
                    class="form-control"
                    placeholder="Enter PO Box"
                >
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-email-input" class="form-label">Town</label>
                <input
                    v-model="localApplication.town"
                    type="text"
                    class="form-control"
                    placeholder="Enter Town"
                >
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-firstname-input" class="form-label">Sub County</label>
                <select
                    v-model="localApplication.subCountyID"
                    class="form-control selectpicker bg-white"
                    title="Select Sub County"
                    data-live-search="true"
                >
                  <option
                      v-for="(sub, index) in subCounties"
                      :key="index"
                      :value="sub.subCountyID"
                  >
                    {{ sub.subCountyName }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-firstname-input" class="form-label">Ward</label>
                <select
                    v-model="localApplication.wardID"
                    class="form-control selectpicker bg-white"
                    title="Select Ward"
                    data-live-search="true"
                >
                  <option
                      v-for="(ward, index) in wards"
                      :key="index"
                      :value="ward.wardID"
                  >
                    {{ ward.wardName }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-xl-12 col-sm-12">
              <div class="mt-4">
                <h5 class="font-size-14 mb-4 text-capitalize">Check where necessary</h5>
                <div class="form-check mb-3">
                  <input
                      v-model="localApplication.status"
                      class="form-check-input"
                      type="radio"
                      name="formRadios"
                      id="formRadios1"
                      value="approved"
                  >
                  <label class="form-check-label" for="formRadios1">
                    This application has been approved
                  </label>
                </div>
                <div class="form-check">
                  <input
                      v-model="localApplication.status"
                      class="form-check-input"
                      type="radio"
                      name="formRadios"
                      id="formRadios2"
                      value="provisional"
                  >
                  <label class="form-check-label" for="formRadios2">
                    This application is provisional
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="handleSubmit" type="button" class="btn btn-primary w-100">Create Certificate</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FoodHygieneModal',

  props: {
    application: {
      type: Object,
      default: () => ({
        businessID: '',
        businessName: '',
        pinNumber: '',
        plotNumber: '',
        phoneNumber: '',
        email: '',
        poBox: '',
        town: '',
        subCountyID: '',
        wardID: '',
        status: 'approved'
      })
    },
    subCounties: {
      type: Array,
      default: () => []
    },
    wards: {
      type: Array,
      default: () => []
    },
    message: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      localApplication: { ...this.application }
    }
  },

  watch: {
    application: {
      handler(newVal) {
        this.localApplication = { ...newVal }
      },
      deep: true
    }
  },

  methods: {
    handleSubmit() {
      // Validation
      if (!this.localApplication.businessID) {
        this.$emit('update:message', 'Business ID is required')
        return
      }
      if (!this.localApplication.businessName) {
        this.$emit('update:message', 'Business Name is required')
        return
      }

      this.$emit('submit-application', this.localApplication)
    }
  }
}
</script>